export default __webpack_public_path__ + "static/media/pastor.50649ad9.jpg";